import { gql } from '@apollo/client';

export const VALIDATE_OPENAI_KEY = gql`
    mutation ValidateOpenAIKey {
        validateOpenAIKey {
            __typename
            ... on SetOpenAIKeySuccess {
                success
                status
            }
            ... on OpenAIKeyError {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
